/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Freeze_Next_BillingInputs */

const fr_membership_freeze_next_billing = /** @type {(inputs: Membership_Freeze_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochain prélèvement le ${i?.date}.`)
};

/**

* @param {Membership_Freeze_Next_BillingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_next_billing = /** @type {((inputs: Membership_Freeze_Next_BillingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Next_BillingInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_next_billing(inputs)
});